// @flow

import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

const Root = styled.div`
  display: flex;
  align-items: center;

  background-color: #3C3C3C;
  color: #FCFCFC;
`;

const NavItem = styled.span`
  padding: 0 6px;
`

const ITEMS = [
  'privacyPolicy',
  'termsOfUse',
]

function FooterNav() {
  return (
    <Root>
      {ITEMS.map((item, index) => (
        <NavItem key={index}>
          <FormattedMessage id={`footerNav.${item}`} />
        </NavItem>
      ))}
    </Root>
  );
}

export default FooterNav;



// WEBPACK FOOTER //
// ./src/components/Footer/FooterNav.js